import { IInvestorDetailsState } from './../../state/investor-details.state';
import { getRegistrationState } from './registration.selectors';
import { createSelector } from "@ngrx/store";
import { IRegistrationState } from "../../state/registration.state";
import { IInvestorDetails } from 'src/app/models/registration/investorDetails';

export const getInvestorDetailsState = createSelector(
    getRegistrationState,
    (state: IRegistrationState) => state.investor
);

export const selectInvestorDetails = createSelector(
    getInvestorDetailsState,
    (state: IInvestorDetailsState) => state.details
);

export const selectInvestorEntityId = createSelector(
    selectInvestorDetails,
    (state: IInvestorDetails) => state.investorEntityId
);

export const selectRegistrantInvestorLegalEntityType = createSelector(
    selectInvestorDetails,
    (state: IInvestorDetails) => {
        return (state?.legalEntityType) ? state.legalEntityType : null;
    }
);

export const selectInvestorName = createSelector(
    selectInvestorDetails,
    (state: IInvestorDetails) => state.name
);

export const selectInvestorReinvestmentOption = createSelector(
    selectInvestorDetails,
    (state: IInvestorDetails) => state.reinvestmentOption
);
